export default {
    liquiditaet: {
        AR_1_Liquiditaet_Girokonto_VRKomplett: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 27,
                },
                Question3a: {
                    key: 'value',
                    value: 'local',
                },
                Question3b: {
                    key: 'value',
                    value: 'allBooking',
                },
            },
        ],
        AR_1_Liquiditaet_Girokonto_VRDirekt: [
            {
                Question3a: {
                    key: 'value',
                    value: 'online',
                },
                Question3c: {
                    key: 'value',
                    value: 'mainAccount',
                },
            },
        ],
        AR_1_Liquiditaet_Girokonto_VRDirektlight: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 27,
                },
                Question3a: {
                    key: 'value',
                    value: 'online',
                },
                Question3c: {
                    key: 'value',
                    value: 'secondaryAccount',
                },
            },
        ],
        AR_1_Liquiditaet_Girokonto_VRIndividual: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 27,
                },
                Question3a: {
                    key: 'value',
                    value: 'local',
                },
                Question3b: {
                    key: 'value',
                    value: 'eachBooking',
                },
            },
        ],
        AR_1_Liquiditaet_Girokonto_VRMeinKonto: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age < 27,
                },
                Question2: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        // ---
        AR_1_Liquiditaet_KreditkarteeasyCredit_GoldCard: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question5: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        AR_1_Liquiditaet_KreditkarteeasyCredit_ClassicCard: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question4: {
                    key: 'value',
                    value: 'yes',
                },
                Question5: {
                    key: 'value',
                    value: 'no',
                },
            },
        ],
        AR_1_Liquiditaet_KreditkarteeasyCredit_easyCredit: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question7: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        // ---
        AR_1_Liquiditaet_BankingApp_BankingApp: [
            {
                Question8: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
    },
    absicherung: {
        AR_2_Absicherung_Sachversicherung_Haftpflichtversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        AR_2_Absicherung_Sachversicherung_KFZVersicherung: [
            {
                Question7: {
                    key: 'car',
                    value: 'yes',
                },
            },
        ],
        AR_2_Absicherung_Sachversicherung_Wohngebaeudeversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question5a: {
                    key: 'value',
                    value: 'yes',
                },
                Question5b: {
                    key: 'age',
                    value: 'house',
                },
            },
        ],
        AR_2_Absicherung_Sachversicherung_Hausratversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        AR_2_Absicherung_Sachversicherung_Rechtsschutzversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        AR_2_Absicherung_Sachversicherung_Tierversicherung: [
            {
                Question8: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        // ---
        AR_2_Absicherung_Einkommensversicherung_Berufsunfaehigkeitsversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age <= 45,
                },
                Question4: {
                    key: 'job',
                    value: (job) => [1, 2, 3, 4].includes(parseInt(job)),
                },
            },
        ],
        AR_2_Absicherung_Einkommensversicherung_Risikolebensversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question2: {
                    key: 'family_status',
                    value: 'couple',
                },
            },
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question3: {
                    key: 'children',
                    value: 'yes',
                },
            },
        ],
        AR_2_Absicherung_Einkommensversicherung_Unfallversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        AR_2_Absicherung_Einkommensversicherung_Kreditversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question6: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        AR_2_Absicherung_Einkommensversicherung_Kontoschutzpolice: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        // ---
        AR_2_Absicherung_Krankenversicherung_Krankenzusatzversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
    },
    vermoegen: {
        AR_3_Vermoegen_Bankeinlagen_Finanzpuffer: [
            {
                Question1: {
                    key: 'value',
                    value: (liquidity) => liquidity === liquidity, // always recommend!
                },
            },
        ],
        // ---
        AR_3_Vermoegen_Sparplan_Fondssparplan: [
            {
                Question3: {
                    key: 'reserve',
                    value: (reserve) => reserve >= 25,
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
            },
        ],
        AR_3_Vermoegen_Sparplan_MeinInvest: [
            {
                Question3: {
                    key: 'reserve',
                    value: (reserve) => reserve >= 25,
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'digital',
                },
            },
        ],
        AR_3_Vermoegen_Sparplan_VermoegenPlus: [
            {
                Question3: {
                    key: 'reserve',
                    value: (reserve) => reserve >= 25,
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'personal',
                },
            },
        ],
        // ---
        AR_3_Vermoegen_Depot_Bankdepot: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'none',
                },
                Question6: {
                    key: 'value',
                    value: (value) => value === 'fonds_and_others' || value === 'dont_know',
                },
            },
        ],
        AR_3_Vermoegen_Depot_UnionDepot: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
            },
        ],
        AR_3_Vermoegen_Depot_MeinInvest: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'digital',
                },
            },
        ],
        AR_3_Vermoegen_Depot_VermoegenPlus: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'personal',
                },
            },
        ],
    },
    vorsorge: {
        AR_4_Vorsorge_Bausparvertrag_Bausparvertrag: [
            {
                Question2: {
                    key: 'property',
                    value: (property) => property === 'yes',
                },
                Question3a: {
                    key: 'renovation',
                    value: (renovation) => renovation === 'yes',
                },
                Question3b: {
                    key: 'renovation_timing',
                    value: (renovation_timing) => renovation_timing === 'not_next_years',
                },
            },
            {
                Question2: {
                    key: 'property',
                    value: (property) => property === 'no',
                },
                Question4a: {
                    key: 'property',
                    value: (property) => property === 'yes',
                },
                Question4b: {
                    key: 'property_timing',
                    value: (property_timing) => property_timing === 'not_next_years',
                },
            },
        ],
        // ---
        AR_4_Vorsorge_StaatlichbAV_RiesterRuerup: [
            {
                Question5: {
                    key: 'job',
                    value: (job) => [1, 2, 3, 4].includes(parseInt(job)),
                },
            },
            {
                Question5: {
                    key: 'job',
                    value: (job) => [6].includes(parseInt(job)),
                },
                Question6: {
                    key: 'employed_partner',
                    value: (employed_partner) => employed_partner === 'yes',
                },
            },
        ],
        AR_4_Vorsorge_StaatlichbAV_BetrieblicheAltersvorsorge: [
            {
                Question2: {
                    key: 'job',
                    value: (job) => [1, 2, 3].includes(parseInt(job)),
                },
            },
        ],
        // ---
        AR_4_Vorsorge_pAV_Kapitallebensversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question7: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
    },
};
